import {
  add2suhfggl4zvkk as add,
  subtract2orl8z9upxd9l as subtract,
  fromInt2ii0rejb1w62w as fromInt,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { Buffergs925ekssbch as Buffer } from '../../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/Buffer.mjs';
import {
  awaitContent$default2x8iq90jfihc1 as awaitContent$default,
  ByteReadChannel2wzou76jce72d as ByteReadChannel,
} from './ByteReadChannel.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function transferFromDelegate($this) {
  updateConsumed($this);
  var appended = $this.k4l_1.u4g($this.j4l_1.g4j());
  $this.l4l_1 = add($this.l4l_1, appended);
}
function updateConsumed($this) {
  $this.m4l_1 = add($this.m4l_1, subtract($this.l4l_1, $this.k4l_1.q2()));
  $this.l4l_1 = $this.k4l_1.q2();
}
var CountedByteReadChannelClass;
function CountedByteReadChannel() {
  if (CountedByteReadChannelClass === VOID) {
    class $ {
      constructor(delegate) {
        this.j4l_1 = delegate;
        this.k4l_1 = new (Buffer())();
        this.l4l_1 = 0n;
        this.m4l_1 = 0n;
      }
      n4l() {
        updateConsumed(this);
        return this.m4l_1;
      }
      t4j() {
        return this.j4l_1.t4j();
      }
      y4j() {
        return this.k4l_1.v3v() && this.j4l_1.y4j();
      }
      g4j() {
        transferFromDelegate(this);
        return this.k4l_1;
      }
      *z4j(min, $completion) {
        if (this.g4j().q2() >= fromInt(min)) {
          return true;
        }
        if (yield* this.j4l_1.z4j(min, $completion)) {
          transferFromDelegate(this);
          return true;
        }
        return false;
      }
      j4k(cause) {
        this.j4l_1.j4k(cause);
        this.k4l_1.l6();
      }
    }
    protoOf($).f4k = awaitContent$default;
    initMetadataForClass($, 'CountedByteReadChannel', VOID, VOID, [ByteReadChannel()], [1]);
    CountedByteReadChannelClass = $;
  }
  return CountedByteReadChannelClass;
}
function counted(_this__u8e3s4) {
  return new (CountedByteReadChannel())(_this__u8e3s4);
}
//region block: exports
export {
  counted as counted3iniv3aql3f9n,
};
//endregion

//# sourceMappingURL=CountedByteReadChannel.mjs.map
